import React, { useEffect, useState } from "react";
import ButtonBlue from "../Button/ButtonBlue";
import DescriptionBlack from "../../common/images-new/description-black.svg";
import { addAttribute, htmlToText, trimString } from "../Helpers/Common";
import { useDispatch, useSelector } from "react-redux";
import { getMyPosts } from "../../redux/actions/showcase";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { serverUrl } from "../Helpers/Config";
import { staticFiles } from "../Helpers/Static";
import ModalRespondTask from "../../pages/Learning/ModalRespondTask";
import {
  ButtonCommonTopNew,
  Card,
  DivBadge,
  TextGray,
} from "../../pages/Theme";
import { Tooltip } from "@mui/material";
import { MdDescription } from "react-icons/md";
import RichContent from "../Editor/RichContent";

const FILE_UPLOAD = staticFiles.fileUpload;


const CardTeachingPreview = ({ data, completed, ...props }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const myPosts = useSelector((state) => state.showcase.myPosts);
  const isDefaultTheme = useSelector((state) => state.auth.isDefaultTheme);
  const [act, setAct] = useState(0);
  const [selected, setSelected] = useState([]);

  const [checked, setChecked] = useState(completed);

  const [showModal, setShowModal] = useState(false);
  const [readMore, setReadMore] = useState(false);

  useEffect(() => {
    setAct(data.action);
  }, [data]);

  return (
    <Card className="cardBackgroundColor relative w-full flex flex-col border20px shadow-sm p-3 md:p-5 md:px-5  px-3 text-sm">
      <div className="flex items-center justify-between mb-3">
        <span className="text-lg blackColor font-semibold ">{data.name}</span>
        <div className="flex items-center">
          {act === 1 && (
            <ButtonCommonTopNew
              className={"cursor-pointer px-5 py-2 rounded-lg text-sm"}
            >
              Respond
            </ButtonCommonTopNew>
          )}
          {act === 0 && (
            <ButtonCommonTopNew
              className={"cursor-pointer px-5 py-2 rounded-lg text-sm"}
            >
              Mark as done
            </ButtonCommonTopNew>
          )}
        </div>
      </div>
      {act == 1 && (
        <div className="flex flex-wrap mb-3">
          <Tooltip title={"Demo post"} placement="top" arrow>
            <DivBadge
              className="flex flex-row items-center rounded-lg px-2 justify-center w-max cursor-pointer"
            >
              <MdDescription className="w-5 h-5 text-white" />
              <span
                rel="noopener noreferrer"
                className="flex text-sm p-1 nav-navigate"
              >
                <div className=" text-white">
                  Demo post
                </div>
              </span>
            </DivBadge>
          </Tooltip>
        </div>
      )}
      <div className="">
        <div className="flex flex-col ">
          <RichContent content={addAttribute(data.detail)} />
        </div>
      </div>

      {/* <div
        className={
          act === 2
            ? "w-3/6 md:w-2/5 flex flex-wrap content-center justify-center"
            : `w-2/5 md:w-1/5 flex flex-wrap content-center justify-center`
        }
      >
        {act === 1 && (
          <div className="flex flex-col-reverse lg:flex-row lg:space-x-10 items-center">
            <div className="flex flex-col">
              <div className="flex flex-row items-center space-x-2 mt-2 lg:mt-0">
                <img src={FILE_UPLOAD} alt="file upload" />
                <TextGray className="hover:opacity-80 underline break-words w-32">
                  {"Demo Post"}
                </TextGray>
              </div>
            </div>

            <div className="flex flex-row lg:flex-col checkGreen undoCheck">
              {isDefaultTheme == false ? (
                <label class={`${"container-check"}`}>
                  <input type="checkbox" checked={true} readOnly={true} />
                  <span class={`${"checkmark cursor-pointer"}`}></span>
                </label>
              ) : (
                <>
                  <input
                    type="checkbox"
                    className="opacity-0 absolute self-center h-10 w-10 cursor-pointer"
                    checked={true}
                    readOnly={true}
                    style={{ position: "fixed" }}
                  />
                  <div className="box bg-gray border rounded border-gray-400 w-10 h-10 flex justify-center items-center mr-3 lg:mr-0">
                    <svg
                      className="mark fill-current hidden w-4 h-4 text-white pointer-events-none"
                      viewBox="0 0 20 20"
                    >
                      <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                    </svg>
                  </div>
                </>
              )}
              <TextGray
                className={` ${
                  isDefaultTheme == false ? "mt-9" : "mt-2"
                } ${"whitespace-nowrap hover:opacity-80"}`}
              >
                Undo
              </TextGray>
            </div>
          </div>
        )}
        {act == 0 && (
          <div className="flex flex-col checkGreen undoCheck">
            {isDefaultTheme == false ? (
              <label class={`${"container-check"}`}>
                <input type="checkbox" checked={true} readOnly={true} />
                <span class={`${"checkmark cursor-pointer"}`}></span>
              </label>
            ) : (
              <>
                <input
                  type="checkbox"
                  className="opacity-0 absolute self-center h-10 w-10 cursor-pointer"
                  checked={true}
                  readOnly={true}
                  style={{ position: "fixed" }}
                />
                <div className="box bg-gray border rounded border-gray-400 w-10 h-10 flex justify-center items-center">
                  <svg
                    className="mark fill-current hidden w-4 h-4 text-white pointer-events-none"
                    viewBox="0 0 20 20"
                  >
                    <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                  </svg>
                </div>
              </>
            )}
            <TextGray
              className={`${
                isDefaultTheme == false ? "mt-9" : "mt-2"
              } ${"whitespace-nowrap mt-2 cursor-pointer hover:opacity-80"}`}
            >
              Undo
            </TextGray>
          </div>
        )}
      </div> */}
    </Card>
  );
};

export default CardTeachingPreview;
